import labelTemplates from './defaultLabelTemplates';
import rowTemplateThresholds from './defaultRowTemplateThresholds';

export default {
	decimal: '.',
	thousands: ',',
	grouping: [3],
	currency: ['$', ''], // '$' stands for dynamic currency symbol (not Dollar). First position in array: currency symbol before value, second position: currency symbol after value
	minus: '-', // not all fonts support the unicode character "hyphen" (\u2212) or "hyphen-minus" (\u002D).
	dateTime: '%a %b %e %X %Y', // %c
	time: '%-I:%M%p', // 12-hour format
	periods: ['am', 'pm'], // %p
	date: '%-m/%-d/%Y', // %x
	days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], // %A
	shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // %a
	months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], // %B
	shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], // %b
	translations: {
		band: {
			overbought: 'Overbought',
			oversold: 'Oversold'
		},
		chart: {
			unavailable: 'Chart not available',
			unavailableIndicator: 'No data available for {0}'
		},
		indicator: {
			previousclose: {
				label: 'Previous Close {0}'
			}
		}
	},
	labelTemplates,
	rowTemplateThresholds
};
